// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Update: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 44"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M27.4 1.1C15.8 1.1 6.5 10.5 6.5 22c0 4.4 1.4 8.6 3.9 12.2l-8.1-1.1c-.8-.1-1.4.4-1.5 1.2-.1.8.4 1.4 1.2 1.5l11.6 1.6h.2c.3 0 .6-.1.8-.3.3-.2.5-.5.5-.9l1.6-11.6c.1-.8-.4-1.4-1.2-1.5-.7-.1-1.4.4-1.5 1.2l-1.2 8.5c-2.3-3.1-3.5-6.8-3.5-10.7 0-10 8.1-18.2 18.2-18.2 10 0 18.2 8.1 18.2 18.2 0 10-8.1 18.2-18.2 18.2-2.2 0-4.3-.4-6.4-1.1-.7-.3-1.5.1-1.8.8s.1 1.5.8 1.8c2.3.9 4.8 1.3 7.3 1.3 11.5 0 20.9-9.4 20.9-20.9S38.9 1.1 27.4 1.1z"/></svg>;
};

export default React.memo(Update);
